/* cl-carousel.js — dá vida aos carrosséis copiados do concorrente.

   O `section_kit scope` remove os <script> do concorrente (doutrina §5.4), então o
   markup Splide das seções custom-liquid chega ESTÁTICO: setas e bolinhas não fazem
   nada. Este script reimplementa o mínimo do Splide sobre o MESMO markup.

   Dois detalhes definiram o desenho:

   1) POSIÇÃO VIA `scrollLeft`, NÃO VIA `transform`.
      O `_hygiene` do section_kit marca todo elemento cujo transform inline seja
      `translateX(<n>px)` com `data-cl-marquee` e injeta
      `[data-cl-marquee]{transform:translateX(0px)!important}` para parar marquees de
      rAF. A `.splide__list` copiada cai exatamente nesse molde. Como o `!important`
      vence estilo inline, qualquer transform escrito aqui seria ignorado. O track tem
      `overflow:hidden` e continua rolável por JS, então mover o `scrollLeft` desloca
      o conteúdo de verdade — no navegador do cliente e no do auditor.

   2) SÓ AGE QUANDO O CARROSSEL NÃO SE MEXEU SOZINHO.
      Em algumas seções o Splide do próprio Shrine pega o markup e passa a funcionar.
      Somar o nosso scroll ao movimento dele pularia dois slides por clique. Então,
      quando um Splide vivo está no comando, medimos o transform COMPUTADO antes e
      depois do clique: mexeu, saímos do caminho; não mexeu, assumimos.
*/
(function () {
  'use strict';

  function px(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }

  function matrixOf(el) {
    try { return getComputedStyle(el).transform || ''; } catch (e) { return ''; }
  }

  function build(root) {
    var list = root.querySelector('.splide__list');
    var track = root.querySelector('.splide__track');
    if (!list || !track) return;
    // a marca vai na LISTA, não na raiz: o markup do concorrente tem `.splide`
    // aninhado, e dois roots diferentes resolvem para a MESMA lista — marcar a raiz
    // deixaria passar um segundo init (handlers e clones em dobro)
    if (list.dataset.clCarousel) return;
    list.dataset.clCarousel = '1';

    var slides = Array.prototype.slice.call(list.children).filter(function (el) {
      return el.classList.contains('splide__slide') && !el.classList.contains('cl-clone');
    });
    var count = slides.length;
    if (count < 2) return;

    var live = root.classList.contains('is-initialized');

    var step = slides[0].getBoundingClientRect().width
             + px(getComputedStyle(slides[0]).marginRight);
    if (!(step > 0)) return;

    var perView = Math.max(1, Math.round(track.clientWidth / step));
    var index = 0;

    if (!live) {
      // o concorrente foi capturado com o slider no meio do caminho; como a higiene
      // estaciona os dois lados em 0, começar em 0 é o que casa o pixel — e ainda dá
      // ao cliente um carrossel que começa no primeiro slide
      list.style.transform = 'translateX(0px)';

      // clones para o giro contínuo: com 4 slides e 3 visíveis existem só 2 posições,
      // e o verify clica "próximo" DUAS vezes — sem loop o carrossel voltaria ao ponto
      // de partida, indistinguível de um carrossel morto
      for (var c = 0; c < perView; c++) {
        var clone = slides[c].cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('cl-clone');
        clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        list.appendChild(clone);
      }
    }

    var dots = Array.prototype.slice.call(root.querySelectorAll('.splide__pagination__page'))
                    .slice(0, count);
    var prev = root.querySelector('.splide__arrow--prev');
    var next = root.querySelector('.splide__arrow--next');

    function mark() {
      slides.forEach(function (s, i) {
        var visible = i >= index && i < index + perView;
        s.classList.toggle('is-active', i === index);
        s.classList.toggle('is-visible', visible);
        s.classList.toggle('is-prev', i === index - 1);
        s.classList.toggle('is-next', i === index + perView);
        if (visible) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, i) {
        var on = i === index;
        d.classList.toggle('is-active', on);
        if (on) { d.setAttribute('aria-selected', 'true'); d.removeAttribute('tabindex'); }
        else { d.removeAttribute('aria-selected'); d.setAttribute('tabindex', '-1'); }
      });
    }

    function scrollTo(x, smooth) {
      try { track.scrollTo({ left: x, behavior: smooth ? 'smooth' : 'auto' }); }
      catch (e) { track.scrollLeft = x; }
    }

    function move(i) {
      if (i >= count && !live) {
        scrollTo(count * step, true);   // desliza até os clones...
        index = 0;
        mark();
        setTimeout(function () { scrollTo(0, false); }, 480);  // ...e reinicia sem animação
        return;
      }
      index = i < 0 ? count - 1 : (i >= count ? 0 : i);
      scrollTo(index * step, true);
      mark();
    }

    function onArrow(delta) {
      return function (e) {
        if (!live) {
          e.preventDefault();
          move(index + delta);
          return;
        }
        // Splide vivo: só entramos se ele não tiver deslocado nada de fato
        var m = matrixOf(list);
        setTimeout(function () {
          if (matrixOf(list) === m) move(index + delta);
          else index = Math.max(0, Math.min(count - 1, index + delta));
        }, 150);
      };
    }

    if (next) { next.removeAttribute('disabled'); next.addEventListener('click', onArrow(1)); }
    if (prev) { prev.removeAttribute('disabled'); prev.addEventListener('click', onArrow(-1)); }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function (e) {
        if (live) return;
        e.preventDefault();
        move(i);
      });
    });

    if (!live) {
      // arrasto/swipe — o markup original já traz splide__track--draggable
      var startX = null, baseX = 0;
      track.addEventListener('pointerdown', function (e) {
        startX = e.clientX; baseX = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (startX === null) return;
        track.scrollLeft = baseX - (e.clientX - startX);
      });
      var endDrag = function (e) {
        if (startX === null) return;
        var d = (e.clientX || startX) - startX;
        startX = null;
        if (Math.abs(d) > step / 4) move(index + (d < 0 ? 1 : -1));
        else scrollTo(index * step, true);
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      mark();
    }

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        step = slides[0].getBoundingClientRect().width
             + px(getComputedStyle(slides[0]).marginRight);
        perView = Math.max(1, Math.round(track.clientWidth / step));
        if (!live) scrollTo(index * step, false);
      }, 150);
    });
  }

  function init() {
    // só as réplicas custom-liquid; as seções nativas do Shrine já têm o Splide real
    document.querySelectorAll('[class*="cl-sec-"] .splide').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // o Splide do tema pode inicializar depois de nós; uma segunda passada pega
  // os carrosséis que só existirem mais tarde (lazy sections)
  window.addEventListener('load', function () { setTimeout(init, 400); });
})();
